import React from 'react';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import { parsePathForStructuredData } from '../utils/structuredData';

// 拡張されたBreadcrumbコンポーネント
// 自動モード: autoMode=true の場合、useLocationから自動でパンくずを生成
// 手動モード: 従来通りpropsでタイトルやスラッグを指定
const Breadcrumb = ({
  title,
  currentPage,
  parentTitle,
  slug,
  parentTitle2,
  slug2,
  autoMode = false, // 新しいオプション：自動モードの有効化
}) => {
  const location = useLocation();

  // 自動モードの場合、locationから情報を取得
  let finalTitle = title;
  let finalParentTitle = parentTitle;
  let finalSlug = slug;
  let finalParentTitle2 = parentTitle2;
  let finalSlug2 = slug2;
  let pathInfo = null;

  if (autoMode && location) {
    pathInfo = parsePathForStructuredData(location.pathname);

    // 手動指定がない場合のみ自動取得した値を使用
    if (!title) {
      finalTitle = title; // titleは通常手動で指定される
    }
    if (!parentTitle && pathInfo.parentSubtitle) {
      finalParentTitle = pathInfo.parentSubtitle;
    }
    if (!slug && pathInfo.parentSlug) {
      finalSlug = pathInfo.parentSlug;
    }
    if (!parentTitle2 && pathInfo.parentSubtitle2) {
      finalParentTitle2 = pathInfo.parentSubtitle2;
    }
    if (!slug2 && pathInfo.parentSlug2) {
      finalSlug2 = pathInfo.parentSlug2;
    }
  }

  // 親ページの正しいパスを生成する関数
  const getParentPath = () => {
    if (autoMode && pathInfo) {
      // 3階層の場合: /grandparent/parent/child/ → 親は /grandparent/parent/
      if (pathInfo.depth === 3) {
        return `/${pathInfo.parentSlug2}/${pathInfo.parentSlug}/`;
      }
      // 2階層の場合: /parent/child/ → 親は /parent/
      else if (pathInfo.depth === 2) {
        return `/${pathInfo.parentSlug}/`;
      }
    }
    // フォールバック: 従来の方法
    return `/${finalSlug}/`;
  };

  // titleからパスを取得する関数
  const getPathFromTitle = (title) => {
    if (title === 'blancブログ') return '/blog/';
    if (title === 'ホームページ制作実績') return '/portfolio/';
    // 他のページタイプがある場合はここに追加
    return `/${title.toLowerCase()}/`;
  };

  // パンくずでのページ番号の表示方法を決定
  const getPageLabel = (title, currentPage) => {
    if (title === 'blancブログ') {
      return `blancブログページ${currentPage}`;
    } else if (title === 'ホームページ制作実績') {
      return `ホームページ制作実績一覧ページ${currentPage}`;
    } else {
      return `${title}ページ${currentPage}`;
    }
  };

  return (
    <>
      <nav aria-label="Breadcrumb" className="breadcrumb">
        <ul>
          <li>
            <Link to="/">ホームページ制作｜blanc</Link>
          </li>

          {/* 2段階上の親ページへのリンク */}
          {finalParentTitle2 && (
            <li>
              <Link to={`/${finalSlug2}/`}>{finalParentTitle2}</Link>
            </li>
          )}

          {/* 親ページへのリンク */}
          {finalParentTitle && (
            <li>
              <Link to={getParentPath()}>{finalParentTitle}</Link>
            </li>
          )}

          {/* 通常のBreadcrumbの機能：ページネーションあり */}
          {finalTitle && !finalParentTitle && <li>{currentPage && currentPage > 1 ? <Link to={getPathFromTitle(finalTitle)}>{finalTitle}</Link> : finalTitle}</li>}

          {/* 子ページタイトル表示 */}
          {finalTitle && finalParentTitle && <li>{finalTitle}</li>}

          {/* ページネーションの表示 */}
          {currentPage && currentPage > 1 && <li>{getPageLabel(finalTitle, currentPage)}</li>}
        </ul>
      </nav>
    </>
  );
};

// 完全自動化版のBreadcrumbコンポーネント
export const AutoBreadcrumb = ({ title, currentPage }) => {
  return <Breadcrumb title={title} currentPage={currentPage} autoMode={true} />;
};

export default Breadcrumb;
